import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {PipeModule} from "../../pipe/pipe.module";
import {CustomSize} from "../../cart/interface/custom-size";
import {CartQuantityInputComponent} from "../cart-quantity-input/cart-quantity-input.component";
import {BloomsightService} from "../../bloomsight.service";
import {WishlistService} from "../../wishlist/wishlist.service";
import {ToastMessageService} from "../../services/toast-message.service";
import {CartInformationService} from "../cart-information.service";
import {CartItem} from "../interface/cart-item";
import {VolumeDiscountProfileItem} from "../../product-details/interface/volume-discount-profile-item";
import {Product} from "../../product-details/interface/product";

@Component({
  selector: 'fb-cart-dialog-item',
  standalone: true,
	imports: [CommonModule, PipeModule, CartQuantityInputComponent],
  templateUrl: './cart-dialog-item.component.html',
  styleUrls: ['./cart-dialog-item.component.scss']
})
export class CartDialogItemComponent implements OnChanges {

	@Input()
	public cartItem: CartItem = {} as CartItem;

	@Input()
	public selectedCurrency: ApCurrency = ApCurrency.INR;
	public quantityFromUser: number = 0;
	public quantityInStock: number = 0;
	public minimumOrderQuantity: number = 1;
	public calculatedPrice: number = 0;
	public calculatedDiscountPrice: number = 0;

	constructor(
		private _bloomsight: BloomsightService,
		private _wishlist: WishlistService,
		private _toast: ToastMessageService,
		private _cartData: CartInformationService
	) {}

	private _calculateCartInformation(cart: CartItem): void  {
		this.quantityFromUser = cart.quantity;
		if(this.cartItem.fabricProductPreview) {
			this.quantityInStock = this._cartData.calculateFabricProductQuantity(
				this.cartItem.fabricProductPreview.product,
				this.cartItem.selectedFabric?.product
			)
			if(this.cartItem.orderType  === 'IN_STOCK') {
				this.minimumOrderQuantity = 1;
			}
			else if(this.cartItem.orderType  === 'MADE_TO_ORDER') {
				this.minimumOrderQuantity = this.cartItem.fabricProductPreview.product.madeToOrderProfileEnabled && this.cartItem.fabricProductPreview.product.madeToOrderProfile ? this.cartItem.fabricProductPreview.product.madeToOrderProfile.minimumOrderQuantity : 1;
			}
			else if(this.cartItem.orderType  === 'PRE_ORDER') {
				this.minimumOrderQuantity = this.calculatePreOrderMinimumOrderQuantity(this.cartItem.fabricProductPreview.product);
			}
		}
		else if(this.cartItem.finishedProductPreview) {
			this.quantityInStock = this._cartData.calculateFinishProductQuantity(
				this.cartItem.finishedProductPreview.product,
				this.cartItem.selectedFabric?.product,
				this.cartItem.selectedSizeOption,
				(this.cartItem.customSize && Object.keys(this.cartItem.customSize).length > 0)
			);

			if(this.cartItem.orderType  === 'IN_STOCK') {
				this.minimumOrderQuantity = 1;
			}
			else if(this.cartItem.orderType  === 'MADE_TO_ORDER') {
				this.minimumOrderQuantity = this.cartItem.finishedProductPreview.product.madeToOrderProfileEnabled && this.cartItem.finishedProductPreview.product.madeToOrderProfile ? this.cartItem.finishedProductPreview.product.madeToOrderProfile.minimumOrderQuantity : 1;
			}
			else if(this.cartItem.orderType  === 'PRE_ORDER') {
				this.minimumOrderQuantity = this.calculatePreOrderMinimumOrderQuantity(this.cartItem.finishedProductPreview.product);
			}
		}

		// console.log(this.quantityFromUser, this.quantityInStock, this.minimumOrderQuantity);
	}

	public calculatePreOrderMinimumOrderQuantity(product: Product): number {
		if (product.volumeDiscountProfileEnabled && product.volumeDiscountProfile) {
			const vDList: VolumeDiscountProfileItem[] = product.volumeDiscountProfile.volumeDiscountProfileItemList.sort((a, b) => a.minimumOrderQuantity - b.minimumOrderQuantity);
			const selectedVD: VolumeDiscountProfileItem | undefined = vDList.find(item => item.preOrder);
			if (selectedVD) {
				return selectedVD.minimumOrderQuantity;
			}
		}
		return 50;
	}

	ngOnChanges(changes: SimpleChanges) {
		if(this.cartItem) {
			this._calculateCartInformation(this.cartItem);
		}
	}

	public prepareCustomSizeLabel(customSizeData: CustomSize): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		for (const [key, value] of Object.entries(customSizeData)) {
			listOfLabel.push(`${key}: ${value}`);
		}
		listOfLabel.reverse();
		label = listOfLabel.join();

		return label;
	}

	public deleteCartItem(id: number | undefined, sku: string, track: boolean = false): void {
		if (track && sku)
			this._bloomsight.trackDataEvent(
				'65f0342afe3931befe4c463b',
				{'sku': sku},
				''
			);
		this._cartData.removeItem(id!);
	}

	public moveToWishlist(id: number, sku: string, productName: string) {
		if (sku) {
			this._bloomsight.trackDataEvent(
				'65f0347bfe3931befe4c4679',
				{sku: sku},
				''
			);
			if (this._wishlist.isInWishlist(sku)) {
				this.deleteCartItem(id, sku);
			} else {
				this._wishlist.toggle(
					productName ? productName : '',
					sku,
					false
				);
				this.deleteCartItem(id, sku);
			}
			this._toast.success("Saved to Wishlist", productName + ' has been moved to wishlist for later');
		}
	}

	public updateCartItemQuantity($event: number): void {
		if (this.cartItem.quantity === $event) return;
		this.cartItem.quantity = $event;
		this._cartData.updateQty(this.cartItem);
	}
}
